import { render, staticRenderFns } from "./CruTable.vue?vue&type=template&id=e36b8178&scoped=true"
import script from "./CruTable.vue?vue&type=script&lang=js"
export * from "./CruTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36b8178",
  null
  
)

export default component.exports